<style scoped lang="scss">
    @import "../../styles/var";
    @import "../../styles/mixins";

    .box {
        padding: 15px;
        background: #ffffff;
        height: 155px;
    }
</style>
<template>
    <v-scroll class="box" ref="scroll" :height="height">
        <message-box-item v-for="(info,index) in list" :info="info" :blank="blank" :key="index"
                          :class="{mt10:index>0}"></message-box-item>
    </v-scroll>
</template>

<script>
  import VScroll from "./v-scroll";
  import MessageBoxItem from "./message-box-item";

  export default {
    name: "message-box",
    components: {MessageBoxItem, VScroll},
    props: {
      blank: {
        type: String,
        default: '0'
      },
      height: {
        type: Number,
        default: 130
      },
      list: Array
    },
    methods: {
      toEnd() {
        this.$refs.scroll.scrollToEnd();
      }
    },
  }
</script>
